import { signInWithRedirect } from "aws-amplify/auth";

import { APP_V2_APP_EVENTS, logEvent } from "../../lib/analytics";

export const RIPPLING_SSO_REQUESTED_URL_KEY = "rippling_sso_requested_url";
export const SSO_PR_PREVIEW_KEY = "sso_pr_preview";

/**
 * Starts the Rippling SSO redirect flow. Called from the login form when
 * the email matches a non-aliased Clipboard Health employee pattern, and
 * from the SSO callback when retrying after account linking or IdP-initiated flows.
 */
interface StartSsoRedirectOptions {
  ssoMode?: string;
  source?: string;
}

export async function startSsoRedirect(
  requestedUrl?: string,
  options?: StartSsoRedirectOptions
): Promise<void> {
  logEvent(APP_V2_APP_EVENTS.RIPPLING_SSO_STARTED, {
    ssoMode: options?.ssoMode,
    source: options?.source,
  });

  const isLoginPath =
    !requestedUrl || requestedUrl === "/enter" || requestedUrl === "/login" || requestedUrl === "/";
  if (!isLoginPath) {
    localStorage.setItem(RIPPLING_SSO_REQUESTED_URL_KEY, requestedUrl);
  } else {
    localStorage.removeItem(RIPPLING_SSO_REQUESTED_URL_KEY);
  }

  storePrPreviewContext();

  await signInWithRedirect({
    provider: { custom: "RipplingEmployees" },
    options: { prompt: "LOGIN" },
  });
}

/**
 * If the app is running in a PR preview (path starts with /pr-{number}/),
 * store the PR number so the root-level SSO callback handler can redirect
 * back to the correct preview build after Cognito returns.
 */
function storePrPreviewContext(): void {
  const prMatch = /^\/pr-(\d+)\//.exec(globalThis.location.pathname);
  if (prMatch) {
    localStorage.setItem(SSO_PR_PREVIEW_KEY, prMatch[1]);
  } else {
    localStorage.removeItem(SSO_PR_PREVIEW_KEY);
  }
}
